import React from 'react';
import '../css/checkout.css'
import OrderService from '../service/OrderService';
import { withRouter } from 'react-router';
import { HiOutlineClock, HiOutlineEmojiSad, HiOutlineShoppingBag } from 'react-icons/hi';
import { MdNavigateNext } from 'react-icons/md';
import { ProductCardSkeleton } from '../components/Skeleton';
import EmptyState from '../components/EmptyState';

class Orders extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orderList: [],
            isCartInProcess: false,
            isLoading: true,
            loadError: false
        };
    }

    redirctMyOrder = (param) => {
        this.props.history.push({
            pathname: '/orders/view/' + param,
            state: { id: param }
        })
    }

    loadOrders = () => {
        this.setState({ isLoading: true, loadError: false })
        OrderService.getYourOrdersListV2().then(res => {
            if (res.status) {
                this.setState({
                    orderList: res.data.data.list,
                    isCartInProcess: res.data.data.isCartInProcess,
                    isLoading: false
                })
            }
        }).catch(error => {
            console.log(error)
            if (error?.response?.status === 401) {
                this.props.history.push('/login')
                return
            }
            this.setState({ isLoading: false, loadError: true })
        });
    }

    componentDidMount() {
        this.loadOrders()
    }

    render() {
        const { orderList, isLoading, loadError, isCartInProcess } = this.state
        const hasOrders = orderList != null && orderList.length > 0
        return (
            <main className='mv-page'>
                <h1 className='mv-list-title'>My orders</h1>

                {isCartInProcess &&
                    <div className='mv-alert mv-alert-info mv-orders-banner' role='status'>
                        <HiOutlineClock /> One of your orders is being processed. We will update you soon.
                    </div>}

                {isLoading &&
                    <div className='mv-orders-grid' aria-busy='true'>
                        {Array.from({ length: 4 }, (_, i) => <ProductCardSkeleton key={i} />)}
                    </div>}

                {!isLoading && loadError &&
                    <EmptyState icon={<HiOutlineEmojiSad />} title='We could not load your orders'
                        text='Please check your connection and try again.' actionLabel='Try again' onAction={this.loadOrders} />}

                {!isLoading && !loadError && !hasOrders &&
                    <EmptyState icon={<HiOutlineShoppingBag />} title='No orders yet'
                        text='Once you place an order, it will appear here.'
                        actionLabel='Start shopping' onAction={() => this.props.history.push('/')} />}

                {!isLoading && !loadError && hasOrders &&
                    <div className='mv-orders-grid'>
                        {orderList.map(order =>
                            <button type='button' key={order.orderId} className='mv-order-card' onClick={() => this.redirctMyOrder(order.orderId)}>
                                <span className='mv-order-media'>
                                    <img src={order.image} alt='' loading='lazy' />
                                </span>
                                <span className='mv-order-body'>
                                    <span className='mv-order-id'>Order #{order.orderId}</span>
                                    <span className='mv-order-link'>View details <MdNavigateNext /></span>
                                </span>
                            </button>
                        )}
                    </div>}
            </main>
        );
    }
}

export default withRouter(Orders);
